import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Config from '../config/Config';
import SectionWrapper from '../components/SectionWrapper';

const NotAuthorizedPage = () => {
  const { mainColor } = Config.appearance;
  const intl = useIntl();

  return (
    <Container className="my-5">
      <SectionWrapper>
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ padding: '30px' }}>
          <h2 className="display-2 fw-bold text-danger">403</h2>
          <p className="fs-3 mt-1">
            {intl.formatMessage({ id: 'access_denied_message' })}
          </p>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button
              variant="primary"
              className="mt-3"
              style={{
                height: '55px',
                borderRadius: '10px', // Right rounded corner
                backgroundColor: mainColor,
                border: 'none',
                width: 'auto',
                minWidth: '65px',
              }}
            >
              {intl.formatMessage({ id: 'back_to_home' })}
            </Button>
          </Link>
        </div>
      </SectionWrapper>
    </Container>
  );
};

export default NotAuthorizedPage;
